import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import {
    FetchRequestOptions,
    fetchService,
    CORS_MODE_NAME,
    GET_METHOD_NAME,
} from 'owa-data-provider-info-fetcher';
import { format } from 'owa-string-utils';
import { getEncodedUrlForVroom } from 'owa-data-provider-info-fetcher';
import { ONE_DRIVE_CONUSMER_API_URL } from 'owa-fileprovider-services';

const getFilePermissionRequestUrlFormat: string = '{0}/v1.0/shares/{1}/driveItem/permissions';

export async function getODCFilePermission(url: string): Promise<ODCLinkPermission> {
    const requestUrl: string = format(
        getFilePermissionRequestUrlFormat,
        ONE_DRIVE_CONUSMER_API_URL,
        getEncodedUrlForVroom(url)
    );
    const requestOptions: FetchRequestOptions = {
        method: GET_METHOD_NAME,
        mode: CORS_MODE_NAME,
        body: null,
        datapointNamePrefix: 'GetODCFilePermission',
    };

    const responseText: string = await fetchService(
        AttachmentDataProviderType.OneDriveConsumer,
        requestUrl,
        null,
        requestOptions,
        null
    );

    const info: GetODCFilePermissions = JSON.parse(responseText);
    let matchedLinkInfo: ODCLinkPermission;
    info.value.forEach(function(element: ODCLinkPermission) {
        if (element.link?.webUrl === url) {
            matchedLinkInfo = element;
        }
    });
    if (!matchedLinkInfo) {
        throw new Error('GetODCSharingInfo failed to find the matching link');
    }
    return matchedLinkInfo;
}

interface GetODCFilePermissions {
    value: ODCLinkPermission[];
}
export interface ODCLinkPermission {
    expirationDateTime: string;
    id: string;
    link: ODCLink;
    shareId: string;
}
interface ODCLink {
    type: string;
    webUrl: string;
}
